import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { TierResponse } from '@models/tier';
import { useTranslation } from 'react-i18next';

interface Props {
    data: TierResponse;
}

function TierCount({ data }:Props) {
    const { t } = useTranslation('tier');
    const { periodEndDDay, currentAccumulatedValue, accumulationType } = data;
    const priceUnit = usePriceUnit();
    const unit = accumulationType === 'STAMP' ? '개' : priceUnit;
    return (
        <Row fullWidth justify='space-between'>
            <Text size='s' color={colors.gray6} fontWeight='medium'>
                {t('tierInfo.current', { value: currentAccumulatedValue.toLocaleString(), unit })}
            </Text>
            <Text size='s' color={colors.gray6} fontWeight='medium'>
                {t('tierInfo.cycleEnd', { days: periodEndDDay })}
            </Text>
        </Row>
    );
}

export default TierCount;
